import type { ComponentProps } from 'react'
import clsx from 'clsx'

import styles from './InfiniteScrollAnchor.module.scss'

const InfiniteScrollAnchor = ({
  className,
  ...props
}: ComponentProps<'div'>) => (
  <div className={clsx(styles.anchor, className)} {...props} />
)

export default InfiniteScrollAnchor
